import { core } from '../core/index.js';

export type FabricWebviewNavigateBackOptions = {
  /**
   * 返回的页面数，如果 delta 大于现有页面数，则返回到首页。
   * @default 1
   */
  delta: number;
  /**
   * 是否计算webview栈中穿插native页面
   * @default true
   */
  includeNativePage?: boolean;
};

export type FabricWebviewNavgateBackApi = (
  options?: FabricWebviewNavigateBackOptions
) => void;

/**
 * 关闭当前页面，返回上一页面或多级页面。可通过获取当前的页面栈, 决定需要返回几层
 */
export const navigateBack: FabricWebviewNavgateBackApi = (
  options: FabricWebviewNavigateBackOptions = {
    delta: 1,
    includeNativePage: true,
  }
) => {
  core.call<'fabric_webview.navigateBack', FabricWebviewNavigateBackOptions>(
    'fabric_webview.navigateBack',
    options
  );
};
